import React from "react";
import Seo from "@/utils/seo";
import Head from "next/head";
import Banner from "@/components/pages/our-products/banner";
import Products from "@/components/pages/our-products/products";
import { getJsonLd } from "@/utils/get-jsonld";
export default function OurProducts() {
  const seo = {
    slug: "/our-products",
  };

  return (
    <>
      <Seo seo={seo} />
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(getJsonLd({ slug: "our-products" })),
          }}
        />
      </Head>
      <Banner />
      <Products />
    </>
  );
}
